module.exports = __webpack_public_path__ + "img/portrait-049.c23c8b83.jpg";